import React, { ReactElement } from 'react'
import { IColorTheme } from '../../types/itemTypes'
import {
  QuantityStyles,
  IncrementButton,
  QuantityCounter,
} from '../buttons/Quantity'

type Props = {
  colorTheme: IColorTheme
  atIncrementLimit: boolean
  count: number | undefined
  onChange: (value: number) => void
}
export default function PricesIncrement(props: Props): ReactElement {
  const {
    colorTheme, atIncrementLimit, count = 0, onChange,
  } = props

  const atDecrementLimit = count <= 0
  const decrement = (): void => {
    if (!atDecrementLimit) onChange(count - 1)
  }

  const increment = (): void => {
    if (!atIncrementLimit) onChange(count + 1)
  }

  return (
    <QuantityStyles style={{ marginRight: 'auto' }}>
      <IncrementButton
        onClick={decrement}
        theme={{ colorTheme, limit: atDecrementLimit }}
      >
        &#8722;
      </IncrementButton>
      <QuantityCounter theme={{ colorTheme }}>{count}</QuantityCounter>
      <IncrementButton
        onClick={increment}
        theme={{ colorTheme, limit: atIncrementLimit }}
      >
        &#43;
      </IncrementButton>
    </QuantityStyles>
  )
}
